import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'h3Date',
  standalone: false,
})
export class H3DatePipe implements PipeTransform {
  transform(value: any) {
    if (value) {
      return formatDate(value, 'yyyy-MM-dd HH:mm:ss UTC', 'en-US', 'UTC');
    } else {
      return '';
    }
  }
}
